module.exports = __webpack_public_path__ + "img/Harvesting & planting events.a030c7c8.png";